import React from "react"
import PropTypes from "prop-types"

import ModernModal from "shared/components/ModernModal"
import Typograph from "../../../../components/Typograph"

import styles from "./styles.css"

import { formatDate } from "services/utils/date"

const SpecialistAnswerModal = ({ isOpen, messages, onCloseModal }) => {
  if (!messages.length) {
    return null
  }
  return (
    <ModernModal
      isOpen={isOpen}
      onClose={() => onCloseModal()}
      removeButton
      confirmButtonText="Fechar"
      onConfirm={() => onCloseModal()}
      customModalClass={styles.specialistModal}
    >
      <div className={styles.messageInfo}>
        <Typograph
          htmlTag="h1"
          size="medium"
          color="outer_space"
          weight="bold"
          classNames={styles.titleModal}
        >
          Resposta do especialista
        </Typograph>

        {messages.map((message, index) => (
          <div key={index} className={styles.modal_details}>
            <div>
              <Typograph
                htmlTag="span"
                size="medium"
                color="outer_space"
                weight="bold"
                classNames={styles.titleModal}
              >
                Data:
              </Typograph>
              <Typograph
                htmlTag="span"
                size="medium"
                color="outer_space"
                weight="regular"
              >
                {formatDate(message.createdAt)}
              </Typograph>
            </div>
            <div>
              <Typograph
                htmlTag="span"
                size="medium"
                color="outer_space"
                weight="bold"
                classNames={styles.titleModal}
              >
                Nota:
              </Typograph>
              <Typograph
                htmlTag="span"
                size="medium"
                color="outer_space"
                weight="regular"
              >
                {message.note}
              </Typograph>
            </div>
          </div>
        ))}
      </div>
    </ModernModal>
  )
}
SpecialistAnswerModal.propTypes = {
  isOpen: PropTypes.bool,
  messages: PropTypes.array,
  onCloseModal: PropTypes.func
}
export default SpecialistAnswerModal



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/MySpecialistRequests/SpecialistAnswerModal.js